
export enum TransactionMode {
    DEFERRED,
    IMMEDIATE,
    EXCLUSIVE
}
